import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class RightService extends BaseService{
	constructor() {
		super('/Right');
	}

	public getAllByFilter(filter: RightFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class RightFilter extends BaseFilter{
	constructor() {
		super();
	}

	public getAllParams(): {} {
		let data = Object.assign({});

		return data;
	};
}